const PREFIX = 'OFFERS_';

export const GET_OFFERS_REQUEST = `${PREFIX}GET_OFFERS_REQUEST`;
export const GET_OFFERS_SUCCESS = `${PREFIX}GET_OFFERS_SUCCESS`;
export const GET_OFFERS_ERROR = `${PREFIX}GET_OFFERS_ERROR`;
